import { MeterSchema } from '@weft/types';
import { oz } from '@weft/utils';
export const MeterForProductPageResponseSchema = MeterSchema.extend({
  contractsCount: oz.number(),
  planNames: oz.string().array(),
}).openapi('MeterForProjectPageResponse');
export const MetersForProductPageResponseSchema = oz.array(MeterForProductPageResponseSchema).openapi('MetersForProjectPageResponse');
  
export type MeterForProductPageResponse = oz.infer<typeof MeterForProductPageResponseSchema>;
export type MetersForProductPageResponse = oz.infer<typeof MetersForProductPageResponseSchema>;